import axios from 'axios';
import { apiEndpoint, assetsEndpoint, wsEndpoint } from './api.js';
import { csrfTokenStore } from '../stores/sessionStore.js';
import { get } from 'svelte/store';


function getCookie(name) {
	if (typeof document === 'undefined') return '';
	const escapedName = name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1');
	const match = document.cookie.match(new RegExp(`(?:^|; )${escapedName}=([^;]*)`));
	return match ? decodeURIComponent(match[1]) : '';
}

function getCsrfToken() {
	return get(csrfTokenStore) || getCookie('csrftoken') || '';
}

export function createAxiosInstance(endpointType = 'api') {
	let baseURL = apiEndpoint;
	const csrfToken = getCsrfToken();
	if (endpointType === 'api') {
		const headers = {
			'Content-Type': 'application/json'
		};
		if (csrfToken) headers['X-CSRFToken'] = csrfToken;
		// Create an instance of axios with default headers
		return axios.create({
			baseURL: baseURL,
			headers,
			withCredentials: true,
			xsrfCookieName: 'csrftoken',
			xsrfHeaderName: 'X-CSRFToken'
		});
	} else if (endpointType === 'assets') {
		baseURL = assetsEndpoint;
		const headers = {};
		if (csrfToken) headers['X-CSRFToken'] = csrfToken;
		return axios.create({
			baseURL: baseURL,
			headers,
			xsrfCookieName: 'csrftoken',
			xsrfHeaderName: 'X-CSRFToken'
		});
	}
}
